import { useEffect, useState } from "react";
import axiosBackend from "../api/axiosBackend";

// Fetches all order statuses once and keeps them sorted by position — shared
// by the orders list/filter/item components (mirrors how Order.js owns shared
// list state and passes it down, rather than each consumer re-fetching).
function useStatuses() {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;

    const fetchStatuses = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosBackend.get("/statuses/get");
        if (!alive) return;
        const data = Array.isArray(response.data) ? response.data : [];
        setStatuses([...data].sort((a, b) => a.position - b.position));
      } catch (err) {
        if (!alive) return;
        console.error("Error fetching statuses:", err);
        setError("אירעה שגיאה בעת טעינת הסטטוסים");
      } finally {
        if (alive) setLoading(false);
      }
    };

    fetchStatuses();

    return () => {
      alive = false;
    };
  }, []);

  return { statuses, loading, error };
}

export default useStatuses;
